import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UploadTooltipMessagePipe } from '../../pipes/upload-tooltip-message.pipe'
import { NgClass } from '@angular/common'
import { NgxTippyModule } from 'ngx-tippy-wrapper'
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'

@Component({
  selector: 'app-upload-input',
  templateUrl: './upload-input.component.html',
  styleUrls: ['./upload-input.component.scss'],
  standalone: true,
  imports: [UploadTooltipMessagePipe, NgClass, NgxTippyModule, ReactiveFormsModule]
})
export class UploadInputComponent {
  public errorMessage!: string
  public isRequired: boolean = false
  public uploadInput: FormControl = new FormControl('')

  @Input() isFileDraggedOver: boolean = false
  @Input() label!: string
  @Input() hint!: string
  @Input() tooltip!: string
  @Input() maxFileSize!: number
  @Input() minFileSize!: number
  @Input() accept!: string
  @Input() showIcon!: boolean
  @Input() warningMessage: string = ''
  @Input() isMultipleInput: boolean = false
  @Input() maxFilesToUpload!: number
  @Input() fileList!: FormGroup | FormArray<FormGroup>
  @Input() appearance: 'multiple-upload' | 'single-upload' = 'single-upload'

  @Output() fileChanged: EventEmitter<File[]> = new EventEmitter<File[]>()

  ngOnInit(): void {
    this.isRequired = this.fileList.hasValidator(Validators.required)
  }

  /**
   * @description Listen to file changes and handle the validation on the uploaded files
   * @param event Event
   */
  public onFileChange(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = false
    const files = Array.from((event.target as HTMLInputElement).files || ((<DragEvent>event).dataTransfer as DataTransfer).files)
    if (!files?.length) return
    this.fileChanged.emit(files)
    this.uploadInput.reset()
  }

  /**
   * @description Changes property based on drag event
   */
  public fileDragOver(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = true
  }

  /**
   * @description Changes property based on drag event
   */
  public fileDragLeave(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = false
  }
}
